import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/monthChangeRule/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/monthChangeRule/detail/v2', Object.assign({}, options, {
    params
  }));
export const remove = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/remove/v2', qs.stringify(params), options);
export const getParkList = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0', Object.assign({}, options, {
    params
  }));



export const removeItem = (formData) => {
  return request({
    url: '/api/v4ward/car/monthChangeRuleDetail/physicsDeleteById/v2',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(formData),
  });
};
// request.post('/api/v4ward/car/monthChangeRuleDetail/physicsDeleteById', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/add/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/update/v2', params, options);

export const invoiceDescription = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/invoiceDescription/v2', params, options);
export const monthChargeRuleList = (params, options) =>
  request.get(
    '/api/v4ward/car/monthChangeRule/monthChargeRuleList/v2',
    Object.assign({}, options, {
      params
    })
  );
export const disable = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/disable/v2', qs.stringify(params), options);

export const removeFeeDetail = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRuleDetail/physicsDeleteById/v2', params, options);

export const monthDiscountRuleList = (params, options) =>
  request.get(
    '/api/v4ward/car/monthDiscountRule/MonthDiscountRuleList/v2',
    Object.assign({}, options, {
      params
    })
  );

export const getFeeSortList = (params, options) =>
  request.get('/api/blade-system/dict/dictionary?code=monthcar_fee_type', Object.assign({}, options, {
    params
  }));

export const monthChargeRuleListV2 = (params, options) =>
  request.get(
    '/api/v4ward/car/monthChangeRule/monthChargeRuleListV2/v2',
    Object.assign({}, options, {
      params
    })
  );


export const initEndTime = (params, options) =>
  request.get(
    '/api/v4ward/car/CarMonth/initEndTime/v2',
    Object.assign({}, options, {
      params
    })
  );

export const carMonthRuleV2 = (params, options) =>
  request.get(
    '/api/v4ward/car/monthDiscountRule/carMonthRuleV2/v2',
    Object.assign({}, options, {
      params
    })
  );

export const editPlusGetDiscountId = (params, options) =>
  request.get(
    '/api/v4ward/car/monthDiscountRule/editPlusGetDiscountId/v2',
    Object.assign({}, options, {
      params
    })
  );
